import script from "./HeroSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroSection.vue?vue&type=script&setup=true&lang=js"

import "./HeroSection.vue?vue&type=style&index=0&id=5419fa5d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5419fa5d"]])

export default __exports__